export const AlertConstants = {
  TYPES: {
    SUCCESS: "success",
    INFO: "info",
    DANGER: "danger",
    WARNING: "warning"
  }
};
